/**
 * Created by tomnotcat on 2021/11/09.
 */
import React from "react";
import { View } from "react-native";
import { Surface, Shape, Path } from "@react-native-community/art";

import Dimensions from "react-native-web-dimension-helper";

class WaveFormSample extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
        var { width, height, strokeWidth, color } = this.props;
        if (width === undefined) {
            width = Dimensions.get("window").width;
        }
        if (height === undefined) {
            height = 50;
        }
        if (strokeWidth === undefined) {
            strokeWidth = 4;
        }
        if (color === undefined) {
            color = '#000';
        }

        const sample1 = [10, 20, 40, 60, 40, 60, 20, 40, 60, 20, 40, 60, 20, 0];
        const sample2 = [0, 30, 50, 40, 50, 40, 20, 50, 40, 20, 50, 40, 20, 20];
        const count = Math.min(sample1.length, sample2.length);
        const path = new Path();
        var x = strokeWidth;
        var w = width / count;
        var hw = height / 2;
        for (var i = 0; i < count; ++i) {
            path.moveTo(x, hw - hw * sample1[i] / 80);
            path.lineTo(x, hw + hw * sample2[i] / 80);
            x += w;
        }
        return (<View style={{width: width, height: height}}>
                <Surface width={width} height={height}>
                <Shape d={path} strokeWidth={strokeWidth} strokeCap='square' stroke={color} />
                </Surface>
                </View>);
    }
}

const styles = {
    text: {
    },
};

export default WaveFormSample;
